export enum RegistrationRadioButtons {
  loginWithEmail,
  registerNewAccount,
  masterAccount
}
